"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var collectionsRef_1 = require("common/db/collectionsRef");
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var firestore_1 = require("react-firebase-hooks/firestore");
var react_i18next_1 = require("react-i18next");
var TextArea = antd_1.Input.TextArea;
function AddNewBudgetTemplateDialog(props) {
    var _this = this;
    var t = (0, react_i18next_1.useTranslation)().t;
    var budgetTemplateSnapshot = (0, firestore_1.useCollection)(collectionsRef_1.budgetTemplatesRef)[0];
    var modalState = props.modalState, setModalState = props.setModalState;
    var formProps = (0, formik_1.useFormik)({
        initialValues: {
            title: "",
            description: "",
        },
        onSubmit: function (values) { return __awaiter(_this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, collectionsRef_1.budgetTemplatesRef.add({
                                description: values.description,
                                title: values.title,
                                createdAt: new Date(),
                            })];
                    case 1:
                        _a.sent();
                        antd_1.message.success(t("alerts.success"));
                        setModalState(false);
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        antd_1.message.success(t("alerts.error"));
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); },
    });
    if (budgetTemplateSnapshot === undefined) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(antd_1.Modal, __assign({ title: "Add Template", open: modalState, onOk: function () { return formProps.handleSubmit(); }, onCancel: function () { return setModalState(false); }, confirmLoading: formProps.isSubmitting }, { children: (0, jsx_runtime_1.jsxs)(antd_1.Form, __assign({ labelCol: { span: 8 }, wrapperCol: { span: 16 } }, { children: [(0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                        formProps.getFieldMeta("title").touched) &&
                        formProps.errors.title &&
                        "error", help: (formProps.submitCount ||
                        formProps.getFieldMeta("title").touched) &&
                        formProps.errors.title, label: t("budget.templateName"), required: true }, { children: (0, jsx_runtime_1.jsx)(antd_1.Input, { value: formProps.values.title, onChange: function (e) { return formProps.setFieldValue("title", e.target.value); } }) })), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                        formProps.getFieldMeta("description").touched) &&
                        formProps.errors.description &&
                        "error", help: (formProps.submitCount ||
                        formProps.getFieldMeta("description").touched) &&
                        formProps.errors.description, label: t("budget.templateDescription"), required: true }, { children: (0, jsx_runtime_1.jsx)(TextArea, { onChange: function (e) {
                            return formProps.setFieldValue("description", e.target.value);
                        }, value: formProps.values.description, style: { width: "100%", margin: "5% 0px", minHeight: 200 } }) }))] })) })));
}
exports.default = AddNewBudgetTemplateDialog;
